import { createAction } from "@reduxjs/toolkit"

export const setVestingList = createAction<any>("vesting/setVestingList")
export const setVestingHistory = createAction<any>("vesting/setVestingHistory")
